/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyIdentityProvider } from '../models/CompanyIdentityProvider';
import type { CreateCompanyIdentityProviderRequest } from '../models/CreateCompanyIdentityProviderRequest';
import type { DomainsData } from '../models/DomainsData';
import type { ProposeSSOConfigurationRequest } from '../models/ProposeSSOConfigurationRequest';
import type { VerifyDomainOwnershipRequest } from '../models/VerifyDomainOwnershipRequest';
import type { VerifyMetadataUrlRequest } from '../models/VerifyMetadataUrlRequest';
import type { VerifySSOConfigurationRequest } from '../models/VerifySSOConfigurationRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IdentityProviderService {

    /**
     * get Active Identity Provider
     * @returns any Success
     * @throws ApiError
     */
    public static getActiveIdentityProvider(): CancelablePromise<{
        activeIdentityProvider: (CompanyIdentityProvider | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/identityProvider',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Identity Provider
     * @returns CompanyIdentityProvider Success
     * @throws ApiError
     */
    public static createIdentityProvider({
        requestBody,
    }: {
        requestBody?: CreateCompanyIdentityProviderRequest,
    }): CancelablePromise<CompanyIdentityProvider> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/identityProvider',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * applySSOConfiguration
     * @returns any Success
     * @throws ApiError
     */
    public static applySsoConfiguration(): CancelablePromise<{
        success: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/identityProvider/applySSOConfiguration',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * verifyMetadataUrl
     * @returns any Success
     * @throws ApiError
     */
    public static verifyMetadataUrl({
        requestBody,
    }: {
        requestBody?: VerifyMetadataUrlRequest,
    }): CancelablePromise<{
        metadataEntityId: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/identityProvider/verifyMetadataUrl',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * verifyDomainOwnership
     * @returns DomainsData Success
     * @throws ApiError
     */
    public static verifyDomainOwnership({
        requestBody,
    }: {
        requestBody?: VerifyDomainOwnershipRequest,
    }): CancelablePromise<DomainsData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/identityProvider/verifyDomainOwnership',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * proposeSSOConfiguration
     * @returns any Success
     * @throws ApiError
     */
    public static proposeSsoConfiguration({
        requestBody,
    }: {
        requestBody?: ProposeSSOConfigurationRequest,
    }): CancelablePromise<{
        testEndpoint: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/identityProvider/proposeSSOConfiguration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * verifySSOConfiguration
     * @returns any Success
     * @throws ApiError
     */
    public static verifySsoConfiguration({
        requestBody,
    }: {
        requestBody?: VerifySSOConfigurationRequest,
    }): CancelablePromise<{
        success: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/identityProvider/verifySSOConfiguration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
